<template>
    <el-timeline-item
        :timestamp="item.timestamp" 
        placement="top"
        :class="active || !collapse ? 'active' : ''"
    >
        <el-card :class="itemStatus[index]">
            <h1 
                @click="onClick"
                @mouseover="active = true"
                @mouseleave="active = false"
            >
                {{item.name}}
            </h1>
            <div>
                <h2>Master Technique:</h2>
                <p v-for="(i, index) in item.syllabus" :key="index">- {{i}}</p>
            </div>
            <div class="resources-container">
                <h2>Resources:</h2>
                <div >
                    <h3 v-if="item.codeLink" @click="$store.commit('GO_STATIC', 'resources/' + item.codeLink)"><i class="fas fa-code"></i>Download Code</h3>
                    <h3 v-if="item.markDown" @click="$store.commit('GO_STATIC', 'resources/' + item.markDown)"><i class="fab fa-markdown" ></i>Download Notes</h3>
                    <h3 v-if="item.materials" @click="$store.commit('GO_STATIC', 'resources/' + item.materials)"><i class="fab fa-book" ></i>Download Materials</h3>
                </div>
            </div>
            <div v-if="item.blogLink">
                <h4>Blog Articles:</h4><a :href="item.blogLink">{{item.blogLink}}</a>
            </div>
        </el-card>
    </el-timeline-item>
</template>

<script>
export default {
    name: 'LearningItem',
    props: ['item', 'index', 'itemStatus', 'switchStatus'],
    data() {
        return {
            height: 1000,
            collapse: true,
            active: false,
            status: 'collapsed'
        }
    },
    methods: {
        onClick(){
            this.active = true
            this.switchStatus(this.index)
        }
    }
}
</script>

<style scoped>
.el-card{
    height: 220px;
    padding: 0 20px;
}
.collapsed{
    height: 50px;
}
h1{
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    font-weight: bold;
    cursor: pointer;
}
h2{
    height: 20px;
    font-size: 15px;
    font-weight: bold;
}
p{
    font-size: 15px;
    line-height: 1.5;
}
.resources-container{
    margin: 10px 0;
    text-align: center;
}
.resources-container h2{
    text-align: left;
}
h3{
    display: inline-block;
    font-weight: normal;
    margin-right: 50px;
    cursor: pointer;
}
h3:hover{
    text-decoration: underline;
}
h3 i{
    margin-right: 5px;
}
h4{
    display: inline-block;
    height: 20px;
    font-size: 15px;
    margin-right: 10px;
    font-weight: bold;
}
</style>